// src/environment/environment.js
const browserHostname =
  typeof window === "undefined" ? "localhost" : window.location.hostname;
const isLocalRuntime = ["localhost", "127.0.0.1", "::1"].includes(
  browserHostname
);

const indexApiBaseUrl =
  process.env.REACT_APP_INDEX_API_BASE_URL ||
  (isLocalRuntime
    ? "http://localhost:1000"
    : "https://indexapi.noptionwave.com");
const stockApiBaseUrl =
  process.env.REACT_APP_STOCK_API_BASE_URL ||
  (isLocalRuntime
    ? "http://localhost:2000"
    : "https://stockapi.noptionwave.com");
const cryptoApiBaseUrl =
  process.env.REACT_APP_CRYPTO_API_BASE_URL ||
  (isLocalRuntime
    ? "http://localhost:4000"
    : "https://cryptoapi.noptionwave.com");
const executionRiskApiRootPath =
  process.env.REACT_APP_EXECUTION_RISK_API_ROOT_PATH ||
  "/api/algotrade/execution-risk";
const executionRiskApiBaseUrl =
  process.env.REACT_APP_EXECUTION_RISK_API_BASE_URL ||
  `${stockApiBaseUrl.replace(/\/$/, "")}/${executionRiskApiRootPath.replace(/^\//, "")}`;

export const environment = {
  production: !isLocalRuntime,

  indexApiTopic: "/index-api-topic",
  optionData: "/index-option-data",
  stoackApiTopic: "/stock-api-topic",
  stockDayRangeDataTopic: "/stock-day-range-topic",
  stockDataAnalysisTopic: "/stock-analysis-topic",
  cryptoApiTopic: "/crypto-api-topic/option-data",
  stockSectorTopic: "/stock-sector-topic",
  nseWebsiteOIResposneDataTopic: "/nse-website-oi-response-data-topic",
  sectorIndicestopic: "/sector-indices-topic",
  strategyIndiciesTopic: "/strategy-indices-topic",
  globalMarketDataTopic: "/global-market-data-topic",
  fiiDiiDataTopic: "/fii-dii-data-topic",
  foTopGainerLooserTopic: "/fo-top-gainer-looser-topic",
  blockDealsLargeStockTopic: "/block-deals-large-stock-topic",
  blockDealsTopStockTopic: "/block-deals-top-stock-topic",
  logicalIndicatorValueTopic: "/logical-indicator-value-topic",
  blockDealsTopStockByDate: "/bdlts/get-bdlts-by-date",
  buyerSellerStockTopic: "/buyer-seller-stock-topic",
  stockScannerTopic: "/stock-scanner-topic",
  atlasScannerTopic: "/atlas-scanner-topic",
  positionalStockSignalsUrl: "/positional-stock/signals",
  positionalStockDailyLevelsUrl: "/positional-stock/daily-levels",
  stockOptionTopic: "/stock-option-topic",
  stockPreOpenDataTopic: "/stock-pre-open-data-topic",
  indexGreeksAnalyseTopic: "/index-greeks-analyse-topic",
  sectorRsiBandScannerTopic: "/sector-rsi-band-scanner-topic",

  baseUrl: indexApiBaseUrl,
  stockApiBaseUrl,
  executionRiskApiBaseUrl,
  executionRiskSaveUrl:
    process.env.REACT_APP_EXECUTION_RISK_SAVE_URL ||
    "/save-execution-risk",
  executionRiskGetAllUrl:
    process.env.REACT_APP_EXECUTION_RISK_GET_ALL_URL ||
    "/get-all-execution-risk",
  executionRiskGetByIdUrl:
    process.env.REACT_APP_EXECUTION_RISK_GET_BY_ID_URL ||
    "/get-execution-risk-by-id",
  executionRiskUpdateUrl:
    process.env.REACT_APP_EXECUTION_RISK_UPDATE_URL ||
    "/update-execution-risk",
  executionRiskDeleteUrl:
    process.env.REACT_APP_EXECUTION_RISK_DELETE_URL ||
    "/delete-execution-risk",
  niftyWebsocketUrl:
    process.env.REACT_APP_INDEX_API_WEBSOCKET_URL ||
    `${indexApiBaseUrl}/index-api-ws-data`,
  stockApiDayRangeDataWSUrl:
    process.env.REACT_APP_STOCK_API_WEBSOCKET_URL ||
    `${stockApiBaseUrl}/stock-api-ws`,
  cryptoApiWSUrl:
    process.env.REACT_APP_CRYPTO_API_WEBSOCKET_URL ||
    `${cryptoApiBaseUrl}/crypto-api-ws`,
};
